import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { maritalStatusesDataSource } from 'infrastructure/data-sources/marital-statuses';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IMaritalStatusItem } from 'infrastructure/data-sources/marital-statuses';

type Options = IBaseSelectBoxOption<
  IMaritalStatusItem['id'],
  IMaritalStatusItem
>[];

interface IMaritalStatusSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const MaritalStatusSelectBox: React.FC<IMaritalStatusSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => maritalStatusesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default MaritalStatusSelectBox;
